import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { ALT_TEXT, IMAGE_PATHS } from 'src/app/core/constants/common.constant';
import { NOTIFICATION_DROPDOWN_CONST } from 'src/app/core/constants/layout.constants';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { LoadingIndicatorComponent } from '@app/shared/components/loading-indicator/loading-indicator.component';
import { SafeHtmlPipe } from '@app/core/pipes/safe-html.pipe';
import { PAYMENT_MODAL_NZ_UI_CONSTANTS } from '@app/core/constants/change-payment-method.constants';

@Component({
  selector: 'app-notification-dropdown',
  standalone: true,
  imports: [LoadingIndicatorComponent, SafeHtmlPipe],
  templateUrl: './notification-dropdown.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationDropdownComponent {
  readonly notificationStore = inject(NotificationService);
  readonly notifications = this.notificationStore.dropdownNotifications;
  readonly notificationCount = computed(() => this.notifications().length);
  readonly isNotificationsLoading = this.notificationStore.isDropdownNotificationsLoading;
  readonly panelClass = input('');
  readonly contentClass = input('');
  readonly listClass = input('');
  readonly footerClass = input('');
  readonly itemGapClass = input('gap-4');
  readonly messageClass = input('leading-8');
  readonly emptyStateClass = input('min-h-40 px-6');
  readonly viewAllText = input(NOTIFICATION_DROPDOWN_CONST.viewAllNotifications);
  readonly panelClose = output<void>();
  readonly viewAll = output<void>();
  readonly notificationsCleared = output<void>();

  readonly IMAGE_PATHS = IMAGE_PATHS;
  readonly ALT_TEXT = ALT_TEXT;
  readonly NOTIFICATION_DROPDOWN_CONST = NOTIFICATION_DROPDOWN_CONST;
  readonly UI_CONSTANTS = PAYMENT_MODAL_NZ_UI_CONSTANTS;

  /**
   * Clears all notifications and emits notificationsCleared event.
   * Parent components listen to this event to refresh the unread count badge.
   */
  clearNotifications(): void {
    this.notificationStore.clearAll('dropdown', () => {
      this.notificationsCleared.emit();
    });
  }

  closePanel(): void {
    this.panelClose.emit();
  }

  onViewAll(): void {
    this.viewAll.emit();
  }

  mergeClasses(base: string, extra: string): string {
    const trimmed = extra.trim();
    return trimmed ? `${base} ${trimmed}` : base;
  }
}
